export default [
  {
    path: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/pc/home/index.vue"),
    meta: {
      title: "如鉴",
    },
  },
];
